module.exports = __webpack_public_path__ + "img/method-pay-check.9ed8f604.svg";